import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import First from '@/components/first.vue'
import My from '@/components/my.vue'
import Zyb from '@/components/zyb.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Index',
    component: Index,
    children: [{
      path: '/',
      name: '首页',
      component: First
    }, {
      path: '/my',
      name: '我的志愿',
      component: My
    }, {
      path: '/zyb',
      name: '志愿表',
      component: Zyb
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js